import {
  Body,
  Box,
  Container,
  Heading,
  SimpleGrid,
  Button,
} from '@hover/blueprint';
import { StaticImage } from 'gatsby-plugin-image';
import React, { useState } from 'react';
import { navigate } from 'gatsby';
import { DownloadAppModal } from '../../common';
import ArrowButton from '../../ui/ArrowButton';
import { CHAT_WITH_US_EXTERIOR_CONTRACTORS_LINK } from '../../../constants';

const ExteriorContractorsHero: React.FC = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const toggleModal = () => setIsOpen(!isOpen);

  return (
    <Container
      maxW="1440px"
      h="auto"
      pt={{ base: 700, desktop: 0 }}
      mb={{ base: 51, desktop: 88 }}
      px={0}
    >
      <DownloadAppModal isOpen={isOpen} onClose={toggleModal} />
      <SimpleGrid
        columns={{ base: 1, desktop: 2 }}
        alignItems="center"
        spacing={100}
      >
        <Container
          alignItems="center"
          maxW="2xl"
          flexDir="column"
          px={500}
          pl={{ base: 500, tablet: 0, desktop: '70px' }}
        >
          <Heading
            size={{ base: 600, tablet: 700, desktop: 800 }}
            style={{ marginBottom: 24 }}
            textAlign={{ base: 'center', desktop: 'left' }}
          >
            Build your business with HOVER.
          </Heading>
          <Body
            textAlign={{ base: 'center', desktop: 'left' }}
            size={500}
            mx={{ base: 'auto', desktop: 0 }}
            maxW={{ base: '90%', tablet: 'md' }}
            mb={700}
          >
            Accurate measurements, fast estimates, direct orders, and happier
            customers mean more time and money to build your business.
          </Body>
          <Box flexDir={{ base: 'column', desktop: 'row' }} alignItems="center">
            <Button
              size="large"
              mb={{ base: 600, desktop: 0 }}
              w={{ base: '100%', tablet: 'auto' }}
              onClick={() => toggleModal()}
            >
              GET STARTED
            </Button>
            <ArrowButton
              mb={{ base: 600, desktop: 0 }}
              variant="minimal"
              w={{ base: '100%', tablet: 'auto' }}
              onClick={() => navigate(CHAT_WITH_US_EXTERIOR_CONTRACTORS_LINK)}
            >
              Chat with us
            </ArrowButton>
          </Box>
        </Container>
        <StaticImage
          quality={100}
          placeholder="blurred"
          src="../../../assets/images/exterior_contractors_hero.png"
          alt="exterior-contractors-hero"
        />
      </SimpleGrid>
    </Container>
  );
};

export default ExteriorContractorsHero;
